import { updateRentalPortalListing } from '../../../../../../../api'
import { useNotification } from '../../../../../../../hooks'
import { getIsListingChangedConflictError } from '../../../../../../RentalPortalListing'
import { useListingProfileContext } from '../../../RentalPortalListingProfile.hooks'

export function useListingProfileHeaderInfoItems() {
  const {
    handleEntityReload,
    handleListingConflict,
    handleOpenResponsibleManagerModal,
    listingData,
  } = useListingProfileContext()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  async function handleSaveAvailableFrom(nextValue) {
    try {
      await updateRentalPortalListing({
        data: { available_from: nextValue },
        id: listingData?.id,
        version: listingData?.version,
      })
      await handleEntityReload()

      handleAddSuccessNotification('Notification.CommonTitleSavedKey')
    } catch (error) {
      if (getIsListingChangedConflictError(error)) {
        await handleListingConflict(error)
      } else {
        handleAddErrorNotification(
          'RentalPortal.ListingProfileAvailableFromSaveErrorKey'
        )

        throw error
      }
    }
  }

  return { handleOpenResponsibleManagerModal, handleSaveAvailableFrom }
}
